import { Input, Modal } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
function TemplateItem({ item, selected, onSelect }) {
  return (
    <div
      className={"templateItem " + (selected && "selected")}
      onClick={() => onSelect(item)}
    >
      <div
        style={{
          display: "inline-block",
          width: "300px",
          textOverflow: "ellipsis",
          fontWeight: "600",
          fontSize: "16px",
          lineHeight: "29px",
        }}
      >
        {item.name}
      </div>
    </div>
  );
}
function saveChangeModal() {
  return new Promise((resolve, reject) => {
    Modal.confirm({
      title: "You have unsaved changes",
      content: "Are you sure you want to discard your unsaved changes?",
      onOk() {
        resolve(true);
      },
      okText: "Discard",
      okButtonProps: {
        className: "primaryButton ",
      },
      cancelButtonProps: {
        className: "primaryButton bordered",
      },
    });
  });
}
export default function TemplateList({
  onSelect,
  onAddClick,
  currentChanged,
  selectedTemplate,
  templateList,
  loading,
}) {
  const [filterString, setFilterString] = useState("");

  return (
    <div
      style={{
        width: "100%",
        textAlign: "start",
      }}
    >
      <div style={{ height: "70px", width: "100%", padding: "0px 24px" }}>
        <Input
          style={{ width: "270px" }}
          size="large"
          placeholder="Search Templates"
          value={filterString}
          onChange={(e) => setFilterString(e.target.value)}
          prefix={<SearchOutlined />}
        />
        <span
          onClick={() => {
            if (currentChanged) {
              saveChangeModal().then((res) => {
                onAddClick?.();
              });
            } else {
              onAddClick?.();
            }
          }}
          className="primaryButton"
          style={{
            padding: "0px",
            height: "40px",
            width: "40px",
            display: "inline-block",
            marginLeft: "20px",
          }}
        >
          <PlusOutlined style={{ color: "white" }} />
        </span>
      </div>
      <div>
        {loading && (
          <div
            className="mask"
            style={{
              zIndex: "99",
              textAlign: "center",
              borderRadius: "8px",
              background: "transparent",
            }}
          >
            <LoadingOutlined style={{ color: "black" }} size={40} />
          </div>
        )}
        {templateList?.map((item) => {
          const selected = selectedTemplate?.id === item.id;
          if (item.name.indexOf(filterString) === -1) return <></>;
          return (
            <TemplateItem
              item={item}
              selected={selected}
              key={item.id}
              onSelect={(value) => {
                if (selectedTemplate.id !== value.id && currentChanged) {
                  saveChangeModal().then((res) => {
                    onSelect(value);
                  });
                } else if (selectedTemplate.id !== value.id) {
                  onSelect(value);
                }
              }}
            />
          );
        })}
      </div>
    </div>
  );
}
